/**
 * @file 用 muses 来转发 sentry 的错误上报
 * @author fuqiang15
 */
import qs from 'qs';
import axios from 'axios';
// muses 上申请的自定义服务
let config = {
    host: 'https://muses.baidu.com', // 正式环境的是 https://muses.baidu.com
    apiPath: '/plain/thirdparty', // 第三方请求固定是这个，不用改
    appid: '15646843', // 该自定义服务所属的appid
    urlId: 'musesplt' // 该自定义服务中你自己配置的「代理URL」
};
export default function request({auth, data, onSuccess, onError}) {
    let url = genUrl(auth);
    let dataStr = encodeURIComponent(JSON.stringify(data));
    data = `data=${dataStr}&contentType=application%2Fx-www-form-urlencoded`;

    return axios({
        url,
        data,
        method: 'post',
        headers: {common: ''}
    }).then(onSuccess, onError);
}
function genUrl(query = {}) {
    let {host, apiPath, appid, urlId} = config;
    let os = {
        '__osInfoParam__': JSON.stringify({
            mcid: '',
            query: '',
            searchTime: Date.now()
        })
    };
    let apiKey = encodeURIComponent(`${appid}_${urlId.replace(/^\//, '').replace(/\?.*$/, '')}`);
    return `${host}${apiPath}?` + qs.stringify({
        apiKey,
        ...os,
        ...query,
        '__osJsonMode__': 1
    });
}
